import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import * as LeadApi from '@/api/lead'

const state = {
  leads: {},
  loading: false,
  error: null
}

const getters = {
  formLeads: (state) => (formId) => {
    return state.leads[formId] || []
  }
}

const mutations = {
  [mutationTypes.FORM_FETCH_LEADS_SUCCESS](state, data) {
    if (data && data.leads && data.formId) {
      state.leads[data.formId] = data.leads
    }
  },

  [mutationTypes.FORM_FETCH_LEADS_ERROR](state) {
    state.error = 'Failed to fetch leads'
  },

  [mutationTypes.FORM_DELETE_LEAD_SUCCESS](state, data) {
    // Remove the deleted lead from the state
    if (data && data.formId && data.leadId) {
      const leads = state.leads[data.formId] || []
      const updatedLeads = leads.filter(lead => lead.id !== data.leadId)
      state.leads[data.formId] = updatedLeads
    }
  },

  [mutationTypes.FORM_ARCHIVE_LEAD_SUCCESS](state, data) {
    // Remove the archived lead from the state
    if (data && data.formId && data.leadId) {
      const leads = state.leads[data.formId] || []
      const updatedLeads = leads.filter(lead => lead.id !== data.leadId)
      state.leads[data.formId] = updatedLeads
    }
  },

  [mutationTypes.FORM_RESTORE_LEAD_SUCCESS](state, data) {
    // Remove the restored lead from the archived list state
    if (data && data.formId && data.leadId) {
      const leads = state.leads[data.formId] || []
      const updatedLeads = leads.filter(lead => lead.id !== data.leadId)
      state.leads[data.formId] = updatedLeads
    }
  },

  [mutationTypes.DELETE_FORM_LEAD_SUCCESS](state, data) {
    // Clear all leads for the form when bulk delete is performed
    if (data && data.formId) {
      state.leads[data.formId] = []
    }
  },

  [mutationTypes.DELETE_FORM_LEAD_ERROR](state, data) {
    state.error = data?.message || 'Failed to delete leads'
  },

  [mutationTypes.FETCH_LEADS_COUNT](state, data) {
    state.leadsCount = data.count
  },



  [mutationTypes.MARK_READ_LEAD_ERROR](state, data) {
    // Handle mark read lead error if needed
  }
}

const actions = {
  [actionTypes.FORM_FETCH_LEADS]({ commit }, data) {
    return LeadApi.getLeads(data)
  },

  [actionTypes.FORM_FETCH_LEADS_SUCCESS]({ commit }, data) {
    commit(mutationTypes.FORM_FETCH_LEADS_SUCCESS, data)
  },

  [actionTypes.FORM_FETCH_LEADS_ERROR]({ commit }) {
    commit(mutationTypes.FORM_FETCH_LEADS_ERROR)
  },

  [actionTypes.FORM_DELETE_LEAD]({ commit }, data) {
    return LeadApi.deleteLead(data)
  },

  [actionTypes.FORM_DELETE_LEAD_SUCCESS]({ commit }, data) {
    commit(mutationTypes.FORM_DELETE_LEAD_SUCCESS, data)
  },

  [actionTypes.FORM_ARCHIVE_LEAD]({ commit }, data) {
    return LeadApi.archiveLead(data)
  },

  [actionTypes.FORM_ARCHIVE_LEAD_SUCCESS]({ commit }, data) {
    commit(mutationTypes.FORM_ARCHIVE_LEAD_SUCCESS, data)
  },

  [actionTypes.FORM_RESTORE_LEAD]({ commit }, data) {
    return LeadApi.restoreLead(data)
  },

  [actionTypes.FORM_RESTORE_LEAD_SUCCESS]({ commit }, data) {
    commit(mutationTypes.FORM_RESTORE_LEAD_SUCCESS, data)
  },

  [actionTypes.DELETE_FORM_LEAD_SUCCESS]({ commit }, data) {
    commit(mutationTypes.DELETE_FORM_LEAD_SUCCESS, data)
  },

  [actionTypes.DELETE_FORM_LEAD_ERROR]({ commit }, data) {
    commit(mutationTypes.DELETE_FORM_LEAD_ERROR, data)
  },

  [actionTypes.FETCH_PARTIAL_LEADS_COUNT]({ commit }, data) {
    return LeadApi.getPartialLeadsCount(data.userId)
  },

  [actionTypes.FETCH_COMPLETE_LEADS_COUNT]({ commit }, data) {
    return LeadApi.getCompleteLeadsCount(data.userId)
  },

  [actionTypes.FETCH_LEADS_COUNT]({ commit }) {
    LeadApi.leadsCount().then((response) => {
      commit(mutationTypes.FETCH_LEADS_COUNT, {
        count: response.data.data.count
      })
    }, (response) => {
      commit(mutationTypes.FETCH_LEADS_COUNT, {
        count: -1
      })
    })
  },



  [actionTypes.MARK_READ_LEAD]({ commit }, data) {
    return LeadApi.markRead(data)
  },

  [actionTypes.MARK_READ_LEAD_ERROR]({ commit }, data) {
    commit(mutationTypes.MARK_READ_LEAD_ERROR, data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
